export default {
	computed: {
		detect() {
			return window.detect;
		}
	}
};
